export default {
	B: 'Bankkonto',
	S: 'Sachkonto',
	A: 'Anlagekonto',
	K: 'Kundenkonto',
	L: 'Lieferantenkonto',
}
